<template lang="pug">
div(style='padding-top: 20px')
    span.titulo Comercialização
    <br/>
    el-row.tabela(:gutter='24')
        el-col(:span='7')
            span.tituloColuna Produto
        el-col(:span='7')
            span.tituloColuna Quantidade
        el-col(:span='7')
            span.tituloColuna Unidade de medida
        el-col(:span='3')
            span.tituloColuna Operações
        el-col(:span='24', style='padding: 0')
            div(
                v-for='(comercializacao, index) in comercializacoes',
                :key='index'
            )
                el-form(:model='comercializacao', :ref='"formCom" + index')
                    el-col(:span='7')
                        el-form-item.margin(prop='produto')
                            el-select(
                                v-model='comercializacao.produto.id',
                                placeholder='Selecione',
                                style='width: 100%',
                                @change='atualizar()'
                            )
                                el-option(
                                    v-for='prod in produtos',
                                    :key='prod.id',
                                    :label='prod.nome',
                                    :value='prod.id'
                                )
                    el-col(:span='7')
                        el-form-item.margin(prop='quantidade')
                            el-input-number(
                                v-model='comercializacao.quantidade',
                                :precision='2',
                                :step='0.01',
                                :min='0.0',
                                style='width: 100%',
                                @change='atualizar()',
                                @blur='handleBlur(index)'
                            )
                    el-col(:span='7')
                        el-form-item.margin(prop='unidadeMedida')
                            el-select(
                                v-model='comercializacao.unidadeMedida.id',
                                placeholder='Selecione',
                                style='width: 100%',
                                @change='atualizar()'
                            )
                                el-option(
                                    v-for='uni in unidadesMedida',
                                    :key='uni.id',
                                    :label='uni.nome + " - " + uni.simbolo',
                                    :value='uni.id'
                                )
                    el-col(:span='3')
                        .block-comercializacao
                            i.el-icon-delete.icon(
                                popup='Remover',
                                @click='openModalRemover(index)',
                                style='color: #900000'
                            )
                            i.el-icon-circle-plus-outline.icon(
                                popup='Adicionar',
                                @click='addCom()'
                            )
    #modal-delete-comercializacao-are-you-sure.row(
        v-if='deleteComercializacaoModal'
    )
        el-dialog(:visible.sync='deleteComercializacaoModal', width='500px')
            span(slot='title')
                h1.mb-2.font-weight-bold(
                    style='text-align: left; font-size: 18px'
                ) Remover comercialização
            .column.d-flex.justify-content-center.align-items-center.flex-column
                h2.mb16 Tem certeza que deseja remover o registro?
                .buttons.buttons-modal.mb16
                    el-button(size='mini', @click='closeModalRemover')
                        | Cancelar
                    el-button(
                        type='danger',
                        size='mini',
                        @click='deleteComercializacao'
                    )
                        | Remover
</template>

<script>
export default {
    name: 'ComercializacaoTerritorio',
    emits: ['getComercializacao'],
    props: {
        comercializacaoSelected: {
            type: Array,
            required: false
        },
        produtos: {
            type: Array,
            required: true
        },
        unidadesMedida: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            comercializacoes: [
                {
                    produto: {
                        id: ''
                    },
                    quantidade: '',
                    unidadeMedida: {
                        id: ''
                    }
                }
            ],
            deleteComercializacaoModal: false,
            indexRemover: null
        };
    },

    mounted() {
        if (
            this.comercializacaoSelected &&
            this.comercializacaoSelected.length > 0
        ) {
            this.comercializacoes = this.comercializacaoSelected;
        }
    },
    methods: {
        openModalRemover(index) {
            this.indexRemover = index;
            this.deleteComercializacaoModal = true;
        },

        closeModalRemover() {
            this.deleteComercializacaoModal = false;
        },

        deleteComercializacao() {
            if (this.indexRemover != null) {
                this.comercializacoes.splice(this.indexRemover, 1);
                if (
                    this.indexRemover === 0 &&
                    this.comercializacoes.length === 0
                ) {
                    this.addCom();
                }
                this.indexRemover = null;
                this.deleteComercializacaoModal = false;
                this.atualizar();
            }
        },

        addCom() {
            this.comercializacoes.push({
                produto: {
                    id: ''
                },
                quantidade: '',
                unidadeMedida: {
                    id: ''
                }
            });
            this.atualizar();
        },

        atualizar() {
            this.$emit('getComercializacao', this.comercializacoes);
        },

        handleBlur(index) {
            if (
                this.comercializacoes[index].quantidade === null ||
                this.comercializacoes[index].quantidade === undefined
            ) {
                this.comercializacoes[index].quantidade = 0;
            }
        }
    }
};
</script>

<style lang="scss">
.titulo {
    font-size: 14px;
    color: dimvar(--gray);
}
.tituloColuna {
    font-size: 13px;
    color: #19194b;
}

.tabela {
    width: 100%;
    padding-top: 15px;
    padding-bottom: 10px;
}
.icon {
    font-size: 20px;
    cursor: pointer;
    padding-top: 10px;
    padding-left: 8px;
    color: #19194b;
}
.margin {
    margin-bottom: 12px;
}

.mb16 {
    margin-bottom: 16px;
}
.buttons-modal {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
}
#modal-delete-comercializacao-are-you-sure {
    text-align: center;
}
.block-comercializacao {
    display: flex;
}
</style>
